import React from 'react';
import { classes, st } from './actionBlocker.st.css';
import { Modal } from '../Modal';
import { Tooltip } from '@wix/wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { isForcedPreview } from '../../selectors/isForcedPreview';
import { FCWithChildren } from '@wix/challenges-web-library';
import { useLocation } from '../../contexts/Location/LocationContext';

export enum ActionBlockerAppearance {
  ModalAppearance = 'Modal',
  PopoverAppearance = 'Popover',
}
export interface IPreviewActionBlockerProps {
  blockerContent: React.ReactNode;
  appearance?: ActionBlockerAppearance;
  onActionBlocked?(): void;
  isActionDisabled: boolean;
  className?: string;
}

export const ActionBlocker: FCWithChildren<IPreviewActionBlockerProps> = (
  props,
) => {
  const { appearance = ActionBlockerAppearance.ModalAppearance } = props;
  const [isWarningShown, toggleWarningModal] = React.useState<boolean>(false);
  const { isPreview } = useEnvironment();
  const onClose = React.useCallback(() => {
    toggleWarningModal(false);
  }, []);
  const { query } = useLocation();

  if (!isPreview && !isForcedPreview(query)) {
    return <>{props.children}</>;
  }

  return (
    <>
      <Tooltip
        disabled={
          appearance !== ActionBlockerAppearance.PopoverAppearance ||
          !props.isActionDisabled
        }
        content={props.blockerContent}
        appendTo="window"
        maxWidth={250}
      >
        <div
          className={st(
            classes.root,
            {
              actionDisabled: props.isActionDisabled,
            },
            props.className,
          )}
          onClick={() => {
            if (props.isActionDisabled) {
              if (appearance === ActionBlockerAppearance.ModalAppearance) {
                toggleWarningModal(true);
              }
              props.onActionBlocked && props.onActionBlocked();
            }
          }}
        >
          {props.children}
        </div>
      </Tooltip>
      {appearance === ActionBlockerAppearance.ModalAppearance && (
        <Modal opened={isWarningShown} onClose={onClose}>
          <div className={classes.warning}>{props.blockerContent}</div>
        </Modal>
      )}
    </>
  );
};
